import { formatPhoneNumber } from "../../../../../../Utils/helper";

const COUNSEL_ENDPOINT = "/api/general/search_filter_counsel/";

export const firmSearchConfig = {
  endpoint: COUNSEL_ENDPOINT,
  buildParams: (query) => ({ firm: query }),
  pickResults: (data) => data?.firms,
  deriveSearchTerm: (r) => r?.office_name ?? "",
  fieldMap: [
    ["id", "counsel_id"],
    ["office_name", "counsel_name"],
    ["address1", "counsel_address1"],
    ["address2", "counsel_address2"],
    ["city", "counsel_city"],
    ["state", "counsel_state"],
    ["zip", "counsel_zip"],
    ["phone", "counsel_phone", formatPhoneNumber],
    ["extension", "counsel_extension"],
    ["fax", "counsel_fax", formatPhoneNumber],
    ["email", "counsel_email"],
    ["website", "counsel_website"],
  ],
};

const attorneyFieldMap = (prefix) => [
  ["id", `${prefix}_dir_id`],
  ["first_name", `${prefix}_first_name`],
  ["last_name", `${prefix}_last_name`],
  ["address1", `${prefix}_address1`],
  ["address2", `${prefix}_address2`],
  ["city", `${prefix}_city`],
  ["state", `${prefix}_state`],
  ["zip", `${prefix}_zip`],
  ["phone", `${prefix}_phone`, formatPhoneNumber],
  ["extension", `${prefix}_extension`],
  ["fax", `${prefix}_fax`, formatPhoneNumber],
  ["email", `${prefix}_email`],
  ["website", `${prefix}_website`],
];

export const attorneySearchConfig = {
  endpoint: COUNSEL_ENDPOINT,
  buildParams: (query) => ({ attorney: query }),
  pickResults: (data) => data?.attorneys,
  deriveSearchTerm: (r) => `${r?.first_name ?? ""} ${r?.last_name ?? ""}`.trim(),
  fieldMap: attorneyFieldMap("attorney"),
};

export const supervisingAttorneySearchConfig = {
  ...attorneySearchConfig,
  fieldMap: attorneyFieldMap("supervisor_attorney"),
};
